import Grid from '@material-ui/core/Grid';
import PeButton from '@pe-libs/react-components/build/components/PeButton';
import { WizardMethodsType } from '@pe-libs/react-components/build/components/PeFormWizard/types';
import PeLoadingElement from '@pe-libs/react-components/build/components/PeLoadingElement';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { getIsOnboardingLoading } from '#modules/auth/selectors';
import messages from '../messages';
import useStyles from '../styles';

const PeOnboardingButtons: FC<WizardMethodsType> = ({ isLastPage }) => {
  const formatMessage = useIntlMessage();
  const buttonSubmitText = isLastPage ? formatMessage(messages.saveandsubmit) : formatMessage(messages.continue);
  const buttonColor = isLastPage ? 'warning' : 'primary';
  const loading = useSelector(getIsOnboardingLoading);
  const styles = useStyles();

  return (
    <Grid item={true} xs={12} className={styles.button}>
      {loading ? (
        <PeLoadingElement color="warning" fullWidth={true} />
      ) : (
        <PeButton
          type="submit"
          color={buttonColor}
          variant="contained"
          fullWidth={true}
          aria-label={`${buttonSubmitText} button`}
        >
          {buttonSubmitText}
        </PeButton>
      )}
    </Grid>
  );
};

export default PeOnboardingButtons;
